import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    // Redirigir al login y guardar la ruta original
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar si el rol del usuario está permitido
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirigir según el rol del usuario
    const roleRoutes: Record<string, string> = {
      management: '/management',
      admin: '/admin',
      client: '/management', // Client también va a /management
      establishment: '/display'
    };
    const defaultRoute = roleRoutes[user.role] || '/management';
    return <Navigate to={defaultRoute} replace />;
  }

  return <>{children}</>;
};

